// extracted by mini-css-extract-plugin
module.exports = {"switchButton":"SwitchBetweenB2BAndNormalModeButton_switchButton__BJ7XV"};